import { WebCrawlScope } from "../__generated__/TrainingSourceListItemFragment.graphql"

namespace TrainingSourceUtils {
  export function getWebcrawlScopeLabel(scope: WebCrawlScope) {
    switch (scope) {
      case "domain":
        return "Linked Pages"
      case "single_page":
        return "Single Page"
      case "subpath": // deprecated
        return "Subpath"
      default:
        return ""
    }
  }
}

export default TrainingSourceUtils
